export default "__VITE_ASSET__78524ba5__"